import React, { Component } from 'react';
import { ChevronLeft, ChevronRight, Plus } from 'lucide-react';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';

const VISIBLE_THUMBS = 4;

export class CarouselAuctionDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            thumbStart: 0,
            lightboxOpen: false,
            lightboxIndex: 0,
        };
    }

    // ── Thumbnail pagination ──
    scrollThumbsLeft = () => {
        this.setState((s) => ({ thumbStart: Math.max(0, s.thumbStart - 1) }));
    };

    scrollThumbsRight = () => {
        const max = Math.max(0, (this.props.images?.length || 0) - VISIBLE_THUMBS);
        this.setState((s) => ({ thumbStart: Math.min(max, s.thumbStart + 1) }));
    };

    selectThumb = (index) => {
        this.setState({ activeIndex: index });
    };

    openLightbox = (index = 0) => {
        this.setState({ lightboxOpen: true, lightboxIndex: index });
    };

    closeLightbox = () => {
        this.setState({ lightboxOpen: false });
    };

    render() {
        const { images } = this.props;
        const { activeIndex, thumbStart, lightboxOpen, lightboxIndex } = this.state;

        if (!images || images.length === 0) return null;

        const lightboxImages = images.map((img) => ({ url: img.image }));
        const totalImages = images.length;

        // Visible window
        const visibleThumbs = images.slice(thumbStart, thumbStart + VISIBLE_THUMBS);
        const hasMoreAfter = thumbStart + VISIBLE_THUMBS < totalImages;

        const canScrollLeft = thumbStart > 0;
        const canScrollRight = thumbStart + VISIBLE_THUMBS < totalImages;

        return (
            <div className="cad-gallery">

                {/* ── Main image ── */}
                <div className="cad-main" onClick={() => this.openLightbox(activeIndex)}>
                    <img
                        className="cad-main__img"
                        src={images[activeIndex]?.image}
                        alt={`Slide ${activeIndex + 1}`}
                    />
                </div>

                {/* ── Thumbnail strip ── */}
                {totalImages > 1 && (
                    <div className="cad-thumbs">
                        {/* Left arrow */}
                        <button
                            className={`cad-thumbs__arrow ${!canScrollLeft ? 'cad-thumbs__arrow--disabled' : ''}`}
                            onClick={this.scrollThumbsLeft}
                            disabled={!canScrollLeft}
                        >
                            <ChevronLeft size={20} />
                        </button>

                        {/* Thumbnails */}
                        <div className="cad-thumbs__track">
                            {visibleThumbs.map((img, i) => {
                                const realIndex = thumbStart + i;
                                return (
                                    <button
                                        key={realIndex}
                                        className={`cad-thumbs__item ${activeIndex === realIndex ? 'cad-thumbs__item--active' : ''}`}
                                        onClick={() => this.selectThumb(realIndex)}
                                    >
                                        <img src={img.image} alt={`Thumb ${realIndex + 1}`} />
                                    </button>
                                );
                            })}

                            {/* + more tile */}
                            {hasMoreAfter && (
                                <button
                                    className="cad-thumbs__item cad-thumbs__item--more"
                                    onClick={() => this.openLightbox(thumbStart + VISIBLE_THUMBS)}
                                >
                                    <Plus size={30} strokeWidth={2} />
                                </button>
                            )}
                        </div>

                        {/* Right arrow */}
                        <button
                            className={`cad-thumbs__arrow ${!canScrollRight ? 'cad-thumbs__arrow--disabled' : ''}`}
                            onClick={this.scrollThumbsRight}
                            disabled={!canScrollRight}
                        >
                            <ChevronRight size={20} />
                        </button>
                    </div>
                )}

                {/* ── Lightbox ── */}
                {lightboxOpen && (
                    <Lightbox
                        images={lightboxImages}
                        startIndex={lightboxIndex}
                        onClose={this.closeLightbox}
                    />
                )}
            </div>
        );
    }
}

export default CarouselAuctionDetails;